import { Observable } from 'rxjs';
import { axiosInstance } from './axios.config.api';
import { map, retry } from 'rxjs/operators';
import { ImpactBoardMemberModel } from '@/models/impact-board-member.model';

export default class ImpactBoardMembersApi {
    getAllMembers(): Observable<ImpactBoardMemberModel[]> {
        return axiosInstance().get<ImpactBoardMemberModel[]>('impact-board/members')
            .pipe(map((response) => response.data));
    }
}
